import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-xl text-primary-400"></i>
                </div>
                <span className="text-lg font-bold text-background-50 whitespace-nowrap">八戒影院</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                电影大全免费观看，高清不缓冲。最新热门影片与电视剧全集同步更新，在线畅看。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <Link to="/category/all" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">全部影片</Link>
                <Link to="/category/action" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">动作片</Link>
                <Link to="/category/comedy" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">喜剧片</Link>
                <Link to="/category/scifi" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">科幻片</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/romance" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">爱情片</Link>
                <Link to="/category/horror" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">恐怖片</Link>
                <Link to="/category/animation" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">动画片</Link>
                <Link to="/category/tvseries" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">电视剧</Link>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
              <div className="flex flex-col gap-2.5">
                <div className="flex items-center gap-2 text-sm text-background-300">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-sm"></i>
                  </div>
                  <span>service@bajiecinema.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-background-300">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-sm"></i>
                  </div>
                  <span>400-000-0000</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-background-300">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  <span>北京市朝阳区建国路88号</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-background-300/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2026 八戒影院 版权所有 | 本站内容仅供交流学习使用
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}